import { useRef } from 'react';

import InfoEllerDriftsmelding from '@helsenorge/core-cms/info-eller-driftsmelding';

import { useAdditionalPageContent } from '../driftspanel/use-additionalPageContent';

import styles from './styles.module.scss';

const Infopanel: React.FC = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [meldinger] = useAdditionalPageContent(ref);

  const infomeldinger = meldinger?.filter(m => m.messageType === 'infomelding' && m.showAfterTitle);

  if (!infomeldinger || infomeldinger.length === 0) {
    return <div ref={ref}></div>;
  }

  return (
    <div className={styles.infopanel} ref={ref}>
      {infomeldinger.map(melding => (
        <InfoEllerDriftsmelding key={melding.id} melding={melding} isVisibleOnFirstRender={false} />
      ))}
    </div>
  );
};

export default Infopanel;
